import Proxy from './Proxy';

class CourseProxy extends Proxy {
    constructor(parameters = {}) {
        super('/course', parameters);
    }

    all(show) {
        if (show) {
            return this.submit('get', `/?show=${show}`);
        }
        return this.submit('get', '/');
    }

    updateCalendarSubscription(id, hidden) {
        return this.submit('put', `/${id}/calendar-subscription`, { hiddenInCalendarSubscription: hidden });
    }
}

export default CourseProxy;
